import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    userId: Yup.number().min(1, "Please select User").required("User is required"),
    trainingTypeId: Yup.number().nullable().required("Please select a Credential Type"),
    trainingSubTypeId: Yup.number().nullable().required("Please select a Credential Sub Type"),
    credentialId: Yup.number().min(1, "Please select a credential").required("Credential is required"),
    effectiveDate: Yup.string().required("Effective date is required"),
    expiryDate: Yup.string().required("Expiry date is required"),
    siteCode: Yup.string().nullable(),
    comments: Yup.string().nullable(),
    imageUrl: Yup.string().nullable(),
});